/*global translate*/
import React, { Component } from 'react'
import { connect } from 'react-redux'
import translate from '../../classes/lang'

global.isclient && require('./rxChangeStatus.css')
const { rxaget, stringToColour, rxChangeSlug, subString ,changeColorSVG} = global.rootRequire('classes/ulti')
const {apiUserStatusList, apiGetUserStatus, apiUpdateStatus } = global.rootRequire('classes/api')
class RxCountUnread_ extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      defaultStatusList:[],
      userStatus:rxaget(this.props, 'userStatus', {})
    }
    this.userid = rxaget(this.props, 'netaauth.user.id', '')
    this.token = rxaget(this.props, 'netaauth.user.token', '')
    // this.token = '0409756ff0046ac24dc2b864d04a1e6e529bsd2V'
  }
  componentDidMount(){
    this.getUserStatusList()
  }

  getUserStatusList(){
    apiUserStatusList(this.token,(json)=>{
      if(json && json.items){
        let defaultStatusList = json.items
        this.setState({defaultStatusList:defaultStatusList})
      }
    })
  }

  onClickClosePopup(){
    this.props.closeChangeStatusPopup()
  }

  onClickDoneBtn(){
    this.submitUpdateStatus()
    this.props.closeChangeStatusPopup()
  }

  chooseStatus(item){
    let userStatus = {
      status_message : item.status_message,
      status_message_en: item.status_message_en
    }
    this.setState({userStatus:userStatus})
  }

  onChangeStatus(event){
    let value = event.target.value
    let userStatus = {
      status_message : value,
      status_message_en: value
    }
    this.setState({userStatus:userStatus})    
  }
  
  submitUpdateStatus(){
    let params = this.state.userStatus
    apiUpdateStatus(this.token, params, (json)=>{
      if(json && json.message === 'success'){
        this.props.updateStatus(params)
      }
    })

  }

  render() {
    let user_status_txt = this.props.langValue === 'en' ? rxaget(this.state, 'userStatus.status_message_en', '') : rxaget(this.state, 'userStatus.status_message', '')

    return(
      <div>
        <div className='zchat_popupscreen'>
          <div className='zchat_popupscreen_bg'></div>
          <div className='zchat_popupscreen_main'>
            <div className='zchat_popupcenter'>
              <div className='zchange_status_popup'>
                <div className='zstatus-header'>
                  <div className='zstatus-btn-area'>
                    <div className='zstatus-close-btn'>
                     <img className='' alt='' src={changeColorSVG('./images/default/icons/icon-basic-up.svg')} onClick={e => this.onClickClosePopup()} />
                    </div>
                    <div className='zstatus-header-title'>{translate('Status')}</div>
                    <div className='zstatus-done-btn' onClick={e => this.onClickDoneBtn()} >{translate('Done')}</div>
                  </div>
                  <div className='zstatus-content'>
                    <div className='zstatus-title'>{translate("Share your status")}</div>
                    <input className='zstatus_input' type='search' maxLength='24' placeholder={translate("Share your status")} value={user_status_txt} onChange={e => this.onChangeStatus(e)}></input>
                  </div>
                </div>
                <div className='zstatus-body'>
                  <div className='zstatus-body-title'>{translate('Suggestion Status')}</div>
                  <div className='zstatus-status-list'>
                    {this.state.defaultStatusList.map(item=>{
                      return(
                        <div className='zstatus-item' key={item.id} onClick={()=>this.chooseStatus(item)}>
                          {this.props.langValue === 'en' ? <div>{item.status_message_en}</div> : <div>{item.status_message}</div>}
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )

  }
}

const mapStateToProps = (state, ownProps) => ({
  // favorite: state.favorite,
  netaauth: state.netaauth,
  // user: state.user,
  langValue: state.langValue,
  // pageValue: state.pageValue,
  // themeValue: state.themeValue, 
  // netaGroups: state.netaGroups,
  // themeBackgroudValue: state.themeBackgroudValue
})

const mapDispatchToProps = {

}

const RxCountUnread = connect(
  mapStateToProps,
  mapDispatchToProps
)(RxCountUnread_)

export default RxCountUnread

